<template>
  <div :class="`modal ${requestPin ? 'is-active' : ''}`">
    <div class="modal-background"></div>
    <div class="modal-content">
      <div class="content p-4 has-background-light">
        <h3 class="is-size-3 has-text-centered">Indtast pinkode</h3>
        <form ref="pincodeForm">
          <div class="pincode-container mb-4 is-flex is-justify-content-space-evenly">
            <div class="pincode-input">
              <input inputmode="numeric" type="password" autocomplete="off" pattern="[0-9]{1}" maxlength="1" v-on:click="handleFocus(0)" v-on:input="handleInput($event, 0)">
            </div>
            <div class="pincode-input">
              <input inputmode="numeric" type="password" autocomplete="off" pattern="[0-9]{1}" maxlength="1" v-on:click="handleFocus(1)" v-on:input="handleInput($event, 1)">
            </div>
            <div class="pincode-input">
              <input inputmode="numeric" type="password" autocomplete="off" pattern="[0-9]{1}" maxlength="1" v-on:click="handleFocus(2)" v-on:input="handleInput($event, 2)">
            </div>
            <div class="pincode-input">
              <input inputmode="numeric" type="password" autocomplete="off" pattern="[0-9]{1}" maxlength="1" v-on:click="handleFocus(3)" v-on:input="handleInput($event, 3)">
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Pincode',
  props:['requestPin'],
  data(){
    return {
      pin:'',
    }
  },
  methods:{
    getInputs(){
      let container = document.querySelector('.pincode-container');
      return container.querySelectorAll('input');
    },
    handleFocus(key){
      let inputs = this.getInputs();
      if (key !== 0) {
        inputs[0].focus();
        inputs[0].setSelectionRange(0, 1);
      }
      
    },
    reset(){
      let inputs = this.getInputs();
      inputs.forEach((input) =>{
        input.value = '';
        this.pin = '';
      });
    },
    handleInput(event, key){
      let inputs = this.getInputs();
      if (!isNaN(event.target.value) && event.target.value.length === 1) {
        if (key === 3) {
          const userCode = [...inputs].map((input) => input.value).join('');
          document.activeElement.blur();
          this.reset();
          this.$emit('hasPincode', userCode);
        } else {
          inputs[key + 1].focus();
          inputs[key + 1].setSelectionRange(0, 1);
        }
        this.pin = [...inputs].map((input) => input.value).join('');
      }
    }
  },
  watch: {
    requestPin(isShow){
      if(isShow === true){
        let inputs = this.getInputs();
        setTimeout(() =>{
          inputs[0].focus();
        }, 0)
      }
    }
  },
};
</script>